module.exports = __webpack_public_path__ + "img/haft-poznan-13.8ddf9f68.jpg";